import React from 'react';

import { SL_WEB_FREESTAR_MIGRATION } from 'common/treatments';
import BlogheradsAd, { type AdConfig } from 'components/BlogheradsAd';
import FreestarAd from 'components/FreestarAd';
import { useTreatments } from 'utils/treatments';

export type { AdConfig };

interface GoogleDFPProps {
  adConfig: AdConfig;
  useUuid?: boolean;
}

const GoogleDFP: React.FC<GoogleDFPProps> = (props) => {
  const treatments = useTreatments();
  if (treatments?.[SL_WEB_FREESTAR_MIGRATION] === 'on') {
    return <FreestarAd {...props} />;
  }
  return <BlogheradsAd {...props} />;
};

export default GoogleDFP;
